import {createRef} from "react";
import {useDispatch} from "react-redux";
import {User} from "../../../../services/UsersService";
import DeleteUrls from "../../../urls/deleteUrls/DeleteUrls";
import BulkDeleteUrls from "../../../urls/bulkDeleteUrls/BulkDeleteUrls";
import AnonymizeUserModal from "../anonymizeUserModal/AnonymizeUserModal";
import {open as openAnonymizeUserModal} from "../anonymizeUserModal/AnonymizeUserModalSlice";
import SeedRendersModal from "../seedRendersModal/SeedRendersModal";
import {open as openSeedRendersModal} from "../seedRendersModal/SeedRendersModalSlice";
import {RequireTier} from "../../../auth/RequireTier";

const REDASH_URL = "https://redash.internal.prerender.io";

interface UserActionsTabProps {
  readonly user: User;
}

const UserActionsTab = (props: UserActionsTabProps) => {
  const {user} = props;
  const dispatch = useDispatch();

  const openServiceRequests = () => {
    window.open(`${REDASH_URL}/queries/240?p_user_id=${user?.id}`, "_blank");
  };

  const openRecacheSpeed = () => {
    window.open(`${REDASH_URL}/queries/172?p_user_id=${user?.id}&p_weeks=3`, "_blank");
  };

  const openAuditLog = () => {
    window.open(`${REDASH_URL}/queries/248?p_user_id=${user?.id}`, "_blank");
  };

  const openRenderCount = () => {
    window.open(`${REDASH_URL}/queries/246?p_user_id=${user?.id}&p_billing_date=${user?.lastCharged}`, "_blank");
  };

  const openRenderCountByStatusCodes = () => {
    window.open(`${REDASH_URL}/queries/247?p_user_id=${user?.id}&p_billing_date=${user?.lastCharged}`, "_blank");
  };

  const openRecacheLog = () => {
    window.open(`${REDASH_URL}/queries/288?p_user_id=${user?.id}`, "_blank");
  };

  const requestIdRef = createRef<HTMLInputElement>();
  const openRenderLog = () => {
    const requestId = requestIdRef.current?.value || "";
    window.open(`${REDASH_URL}/queries/287?p_user_id=${user?.id}&p_request_id=${requestId}`, "_blank");
  };

  const showAnonymizeUserModal = () => {
    dispatch(openAnonymizeUserModal(user));
  };

  const showSeedRendersModal = () => {
    dispatch(openSeedRendersModal());
  };

  return (
    <>
      <AnonymizeUserModal />
      <SeedRendersModal userId={user.id} />
      <div className="row align-items-center">
        <div className="card">
          <div className="card-header">
            <h4 className="card-header-title">Redash</h4>
          </div>
          <div className="card-body">
            <div className="form-group">
              <button onClick={openServiceRequests} className="btn btn-primary">
                Service request
              </button>
            </div>
            <div className="form-group">
              <button onClick={openRecacheLog} className="btn btn-primary">
                Recache log
              </button>
            </div>
            <div className="form-group">
              <button onClick={openRecacheSpeed} className="btn btn-primary">
                Recache speed
              </button>
            </div>
            <div className="form-group">
              <button onClick={openAuditLog} className="btn btn-primary">
                Audit log
              </button>
            </div>
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <button onClick={openRenderCount} className="btn btn-primary">
                    Render count
                  </button>
                </div>
              </div>
              <div className="col">
                <div className="form-group">
                  <button onClick={openRenderCountByStatusCodes} className="btn btn-primary">
                    Render count by status codes
                  </button>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-2">
                <label className="form-label" htmlFor="requestId">
                  RequestId:
                </label>
              </div>
              <div className="col-4">
                <div className="form-group">
                  <input id="requestId" className="form-control" type="text" ref={requestIdRef} />
                </div>
              </div>
              <div className="col">
                <button onClick={openRenderLog} className="btn btn-primary">
                  Render logs
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row align-items-center">
        <DeleteUrls userId={user.id} />
      </div>
      <div className="row align-items-center">
        <BulkDeleteUrls userId={user.id} />
      </div>
      <RequireTier requiredTier="superadmin" policy="hide">
        <div className="form-group">
          <label htmlFor="id" className="form-label mb-0">
            Anonymize user
          </label>
          <div className="mt-0 mb-2">
            <small className="text-muted">Hash the personal data and clear cache</small>
          </div>
          <button className="btn btn-danger" onClick={showAnonymizeUserModal}>
            Anonymize user (company)
          </button>
        </div>
      </RequireTier>
      <div className="form-group mt-3">
        <label className="form-label mb-0">Seed renders</label>
        <div className="mt-0 mb-2">
          <small className="text-muted">Insert synthetic render records (staging only)</small>
        </div>
        <RequireTier requiredTier="admin" policy="disable">
          <button className="btn btn-warning" onClick={showSeedRendersModal}>
            Seed renders
          </button>
        </RequireTier>
      </div>
    </>
  );
};

export default UserActionsTab;
